import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const signIn = createAsyncThunk(
  "login/signIn",
  async (arg) => {
      return httpRequest(`${BASE_URL}/ManageUser/ManagementAccess?UserName=${arg.username}&PassWord=${arg.password}`);
  }
)

const authenticationSlice = createSlice({
  name: "login",
  initialState: {
    login: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.login = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  } 

});


export default authenticationSlice.reducer;
